"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const ToolbarButton = props => {
    const { editorId = "mui-rte", inlineMode, onClick, id, label, size, style, type, disabled = false, icon, active, component: Component, } = props;
    const toolbarId = inlineMode ? "-toolbar" : "";
    const elemId = editorId + "-" + (id || label) + "-button" + toolbarId;
    const mouseDownHandler = (e) => {
        e.preventDefault();
        if (onClick) {
            onClick(style, type, elemId, inlineMode);
        }
    };
    if (icon) {
        return ((0, jsx_runtime_1.jsx)(material_1.IconButton, { id: elemId, "aria-label": label, color: active ? "primary" : "default", size: !inlineMode ? size || "medium" : "small", disabled: disabled, onMouseDown: mouseDownHandler, "data-testid": "toolbar-button", children: icon }));
    }
    if (Component) {
        return ((0, jsx_runtime_1.jsx)(Component, { id: elemId, active: active || false, disabled: disabled, onMouseDown: mouseDownHandler, "data-testid": "toolbar-button" }));
    }
    return null;
};
exports.ToolbarButton = ToolbarButton;
//# sourceMappingURL=index.js.map